import { IQueryCommandOptions } from '@llws/dynamic-router-utils';
import {
  IFloorplanNavigatorInstanceFloors,
} from '@llws/lift-entity-interfaces';
import { StoreBaseImplementationV2 } from '../../shared/classes/store-base-implementation-v2';

const adminGatewayResourcePath: string = '/web-components-api/floorplan_navigator_instance_floors';
const listViewName: string = '';
const showLogging: boolean = false;
const defaultGetListFilters: IQueryCommandOptions = {
  relations: [
    { path: 'fpni.fpniBuildingHasFloors', alias: 'fpnibhf' },
  ],
  select: [
    'fpni.id',
    'fpni.fpnInstanceId',
    'fpni.importFloorId',
    'fpni.label',
    'fpni.floormapPath',
    'fpni.order',
    'fpnibhf.id',
    'fpnibhf.buildingId',
    'fpnibhf.fpnInstanceFloorId',
    'fpnibhf.floorNumber',
  ],
  orderBy: [
    { field: 'fpni.order', direction: 'asc' },
  ],
  limit: 'false',
  alias: 'fpni',
};
const defaultGetSingleFilters: IQueryCommandOptions = {
  alias: 'fpni',
  relations: [
    { path: 'fpni.fpniBuildingHasFloors', alias: 'fpnibhf' },
  ],
  select: [
    'fpni.id',
    'fpni.fpnInstanceId',
    'fpni.importFloorId',
    'fpni.label',
    'fpni.floormapPath',
    'fpni.order',
    'fpnibhf.id',
    'fpnibhf.buildingId',
    'fpnibhf.fpnInstanceFloorId',
    'fpnibhf.floorNumber',
  ],
  orderBy: [{ field: 'fpni.order', direction: 'asc' }],
};
const base = new StoreBaseImplementationV2<IFloorplanNavigatorInstanceFloors>({
  adminGatewayResourcePath,
  defaultGetSingleFilters,
  defaultGetListFilters,
  listViewName,
  showLogging,
});

export default {
  namespaced: base.namespaced,

  state: {
    ...base.state,
  },

  getters: {
    ...base.getters,
  },

  mutations: {
    ...base.mutations,
  },

  actions: {
    ...base.actions,
  },
};
